import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_r7tt2vf93c: FaireBrandEntity = {
  token: "b_r7tt2vf93c",
  type: "brand",
  name: "Barefoot Beauties",
  avatarUrl:
    "https://cdn.faire.com/fastly/763bfe5738e33fbdc62784400f7d3b70610e39eb88cea3a0e144dcad99f30bfd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1b75a3d115cca89a619535a22ffd30177b0d7d5dc2b3318ea6ed785554b5df2e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/763bfe5738e33fbdc62784400f7d3b70610e39eb88cea3a0e144dcad99f30bfd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1b75a3d115cca89a619535a22ffd30177b0d7d5dc2b3318ea6ed785554b5df2e.jpeg",
  location: "Roby, MO, USA",
  minimumOrderDollars: 0,
  rating: 4.6,
  reviewCount: 24,
  isInsider: true,
  description:
    "In the heart of the rural Midwest, a rancher's daughter found solace in nature's vastness. Raised with values of hard work, she developed a keen eye for fashion. Homeschooling her five children didn't dampen her passion. Instead, it fueled her drive to blend rustic charm with urban elegance. Her brand tells a story of rural roots and cosmopolitan flair, inviting others to embrace simplicity and individual expression.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:12.761Z",
    importedBy: "entity-db-cli",
  },
};
